import * as React from 'react';

import { usePortfolioProject } from 'bundles/unified-description-page-common/contexts/PortfolioProjectCheckContext';
import { useCoursePageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffCourseContext';
import ConsumerGuidedProjectPageRootContent from 'bundles/unified-description-page-common/pages/consumer/project/ConsumerGuidedProjectPageRootContent';
import ConsumerPortfolioProjectPageRootContent from 'bundles/unified-description-page-common/pages/consumer/project/ConsumerPortfolioProjectPageRootContent';
import ConsumerProjectPageRootContent from 'bundles/unified-description-page-common/pages/consumer/project/ConsumerProjectPageRootContent';
import { checkIsGuidedProject } from 'bundles/unified-description-page-common/utils';

const ConsumerPageDirector = () => {
  const { isPortfolioProject } = usePortfolioProject();
  const pageData = useCoursePageData();

  if (!pageData || !pageData.courseType) {
    return null;
  }

  const isGuidedProject = checkIsGuidedProject(pageData?.courseType);

  if (isPortfolioProject) {
    return <ConsumerPortfolioProjectPageRootContent />;
  } else if (isGuidedProject) {
    return <ConsumerGuidedProjectPageRootContent />;
  } else {
    return <ConsumerProjectPageRootContent />;
  }
};

export default ConsumerPageDirector;
